import type { Doc } from '../_generated/dataModel'
import type { QueryCtx } from '../_generated/server'

export const MUST_DO_LIMIT = 3

export const addDaysStr = (day: string, n: number) =>
  new Date(Date.parse(`${day}T00:00:00Z`) + n * 86_400_000).toISOString().slice(0, 10)

export const daysBetween = (from: string, to: string) =>
  Math.round((Date.parse(`${to}T00:00:00Z`) - Date.parse(`${from}T00:00:00Z`)) / 86_400_000)

// Committed tasks for `day`: due on or before it (carried over until done), plus
// the ones finished today so they stay checked off in the lane.
export async function mustDoTasks(
  ctx: QueryCtx,
  userId: string,
  day: string,
  dayStartMs: number,
): Promise<Doc<'nodes'>[]> {
  const rows = await ctx.db
    .query('nodes')
    .withIndex('by_user_mustDoOn', (q) =>
      q.eq('userId', userId).gte('mustDoOn', '0000').lte('mustDoOn', day),
    )
    .take(50)
  return rows.filter(
    (n) =>
      n.type === 'task' &&
      !n.isHabit &&
      n.archivedAt == null &&
      (n.completedAt === null || n.completedAt >= dayStartMs),
  )
}

export async function queuedMustDo(ctx: QueryCtx, userId: string, day: string) {
  const rows = await ctx.db
    .query('nodes')
    .withIndex('by_user_mustDoOn', (q) => q.eq('userId', userId).eq('mustDoOn', addDaysStr(day, 1)))
    .take(20)
  return rows.filter((n) => n.completedAt === null && n.archivedAt == null)
}
